<template>
  <div>
    <slide></slide>
    <all-Courses></all-Courses>
  </div>
</template>
<script>
import slide from "../common/carousel";
import allCourses from "../allCourse/CourseList";

export default {
  data() {
    return {
      searchForm: {
        campusId: "0",
        course: "",
      },
      pageTotal: 0,
      currNum: 1,
      listData: [],
      basicData: {},
      isWeChatBrowser: false, //是否为微信浏览器
    };
  },
  components: {
    slide,
    allCourses,
  },
  methods: {
     // 检查是否为微信浏览器
    checkWeChatBrowser() {
      const userAgent = navigator.userAgent.toLowerCase();
      const isWeChat = userAgent.includes('micromessenger');
      
      if (!isWeChat) {
        this.isWeChatBrowser = false;
      } else {
        this.isWeChatBrowser = true;
      }
    },
    getCode() {
    
      if (this.isWeChatBrowser) {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');
        if (code) {
        
          return code;
        }
        
        const appid = "wxe97386fcfdf3c866";
        const redirectUri = encodeURIComponent(`http://tjltb.tongji.edu.cn/retireSchool/login/wechat`);
 
        const wechatAuthUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUri}&response_type=code&scope=snsapi_base#wechat_redirect`
        
        window.location.href = wechatAuthUrl;
      }
  
   
    },
    
    
  },
  
  created() {

    this.checkWeChatBrowser();
    if (!this.isWeChatBrowser) {
       this.$router.push({ name: "home" });
    } else {

      let status = sessionStorage.getItem('status');
      if(status === '0' || status === '1'){
        this.$router.push({ name: "home" });
      } else {
        this.getCode();   
      }
    }
 
    
  },
};
</script>
